export default "__VITE_ASSET__iRXrD2Md__"